import { useEffect, useState } from 'react';

import type { ColorSwatches } from '@/util/color_swatch';
import { fetchColorSwatches } from '@/util/color_swatch_client';

/**
 * Color filter swatches, or null until they load (and for good if unavailable).
 * @client Client side only hook
 */
export const useColorSwatches = (): ColorSwatches | null => {
  const [swatches, setSwatches] = useState<ColorSwatches | null>(null);

  useEffect(() => {
    let active = true;
    fetchColorSwatches().then((result) => {
      if (active) setSwatches(result);
    });
    return () => {
      active = false;
    };
  }, []);

  return swatches;
};
